export default class MultiSelect {
    formatOptions (options, groupValues) {
        if (groupValues) {
            // this nested for loop is for groups of options so the outer for loop should never get too
            // long
            return options.map((optionGroup) => {
                const optionKey = Object.keys(optionGroup)[0];
                optionGroup[optionKey] = optionGroup[optionKey].map((option) => {
                    return this.standardizeIcon(option);
                });

                return optionGroup;
            });
        }

        return options.map((option) => {
            return this.standardizeIcon(option);
        });
    }

    standardizeIcon (option) {
        option.icon = option.iconLabel || option.iconUrl;

        return option;
    }
}

export const MultiSelectService = new MultiSelect();
